<template>
<div>
  <label>Sabab</label>
  <b-form-textarea
      id="textarea"
      v-model="text"
      placeholder="Enter something..."
      rows="3"
      max-rows="6"
  ></b-form-textarea>
  <div class="button">
    <b-button variant="primary">Yuborish</b-button>
  </div>
</div>
</template>

<script>
export default {
  name: "DenyTest",
  data(){
    return{
      text:''
    }
  }
}
</script>

<style scoped>
.button{
  margin-top: 20px;
  margin-left: 200px;
}
</style>
